

import React, { useState, useEffect, useRef } from 'react'
import { Link } from "react-router-dom";
import { Select, Col, Row, Input, Checkbox, Radio } from "antd";
import backButton from '../../../assets/images/back_button_arrow.svg';
import axios from "axios";
import { notifysuccess } from "../../../utils/toast";
import { notifyfailure } from "../../../utils/toast";
import { notifycatch } from "../../../utils/toast";
import Cookies from "js-cookie";
import configData from "../../../config/config.json";
import loaderIcon from "../../../assets/images/login-and-signup/loader.gif";
import demandIcon from '../../../assets/images/icons/demand_icon.svg';
import FullLoader from "../../../assets/images/full-page-loader.gif";

const SiteCreatePubmatic = ({ handlePageViewChange }) => {


    // //////////////////////////////////////////////////////////////

    const scrollToItem = (ref, offset = 80) => {
        if (ref && ref.current) {
            ref.current.style.scrollMarginTop = `${offset}px`;
            ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
            setTimeout(() => {
                ref.current.style.scrollMarginTop = '';
            }, 500);
        }
    };

    const { TextArea } = Input;

    useEffect(() => {
        const inputs = document.querySelectorAll('.ant-select-selection-search-input');

        inputs.forEach(input => {
            const handleInput = () => {
                const parent = input.closest('.ant-select-selection-search');
                if (input.value.length > 0) {
                    parent.classList.add('searching');
                } else {
                    parent.classList.remove('searching');
                }
            };

            input.addEventListener('input', handleInput);

            // Cleanup event listener on component unmount
            return () => {
                input.removeEventListener('input', handleInput);
            };
        });
    });


    const [buttonProcessing, setButtonProcessing] = useState(false);



    // ------------------------------  Pubmatic Code -----------------------------------------------------------
    // ---------------------------------------------------------------------------------------------------------


    useEffect(() => {

        axios
            .get(configData.SERVER_URL + "ops/iabCategories", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setIabCategoryOptions_web_pubmatic(response.data.data)
                setIabCategoryOptions_app_pubmatic(response.data.data)

            })
            .catch((error) => { });



    }, [])


    const [platform_pubmatic, setPlatform_pubmatic] = useState(1);
    const [platformOptions_pubmatic] = useState([{ label: "Web", value: 1 },
    { label: "Mobile App Android", value: 5 },
    { label: "Mobile App IOS", value: 4 },
    { label: "CTV", value: 7 }

    ]);


    function onChangePlatform_pubmatic(event) {
        resetWeb()
        resetAndroidIOS()
        resetCtv()
        setPlatform_pubmatic(event);
    }

    // ------------------------------  Pubmatic Code Web and CTV  -----------------------------------------------------------
    // ---------------------------------------------------------------------------------------------------------

    //common fields for web and ctv

    const [siteDomain_web_pubmatic, setSiteDomain_web_pubmatic] = useState("");
    const [siteDomainIsRequiredError_web_pubmatic, setSiteDomainIsRequiredError_web_pubmatic] = useState(false);
    const [siteDomainValidError_web_pubmatic, setSiteDomainValidError_web_pubmatic] = useState(false);
    // const regexDomain = /.+[.].+/;
    const regexDomain = /^(https?:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;

    const [siteIdentifier_web_pubmatic, setSiteIdentifier_web_pubmatic] = useState("");
    const [siteIdentifierIsRequiredError_web_pubmatic, setSiteIdentifierIsRequiredError_web_pubmatic] = useState(false);

    const [checkbox_secure_web_pubmatic, setCheckbox_secure_web_pubmatic] = useState(false);

    const [iabCategory_web_pubmatic, setIabCategory_web_pubmatic] = useState("");
    const [iabCategoryIsRequiredError_web_pubmatic, setIabCategoryIsRequiredError_web_pubmatic] = useState(false);
    const [iabCategoryOptions_web_pubmatic, setIabCategoryOptions_web_pubmatic] = useState([]);

    const [monthlyAdImpression_web_pubmatic, setMonthlyAdImpression_web_pubmatic] = useState(">1M");
    const [monthlyAdImpressionOptions_web_pubmatic] = useState([{ label: "<10000", value: "<10000" }, { label: ">10000", value: ">10000" }, { label: ">100000", value: ">100000" }, { label: ">1M", value: ">1M" }, { label: ">10M", value: ">10M" }, { label: ">100M", value: ">100M" }, { label: ">1B", value: ">1B" }]);


    const [checkbox_coppa_web_pubmatic, setCheckbox_coppa_web_pubmatic] = useState(false);


    const [privacyPolicyUrl_web_pubmatic, setPrivacyPolicyUrl_web_pubmatic] = useState("");
    const [privacyPolicyUrlInvalidError_web_pubmatic, setPrivacyPolicyUrlInvalidError_web_pubmatic] = useState(false);

    const [contentObject_web_pubmatic, setContentObject_web_pubmatic] = useState("0");

    const [checkbox_api_web_pubmatic, setCheckbox_api_web_pubmatic] = useState(false);

    function resetWeb() {
        setSiteDomain_web_pubmatic("");
        setSiteDomainIsRequiredError_web_pubmatic(false);
        setSiteDomainValidError_web_pubmatic(false);
        setSiteIdentifier_web_pubmatic("");
        setSiteIdentifierIsRequiredError_web_pubmatic(false);
        setCheckbox_secure_web_pubmatic(false);
        setIabCategory_web_pubmatic("");
        setIabCategoryIsRequiredError_web_pubmatic(false);
        setMonthlyAdImpression_web_pubmatic(">1M");
        setCheckbox_coppa_web_pubmatic(false);
        setPrivacyPolicyUrl_web_pubmatic("");
        setPrivacyPolicyUrlInvalidError_web_pubmatic(false);
        setContentObject_web_pubmatic("0");
        setCheckbox_api_web_pubmatic(false);
        // setCheckbox_overridePublisherData_ctv_pubmatic(false);
        // setAppStore_ctv_pubmatic(999999);
    }

    function onChangeSiteDomain_web_pubmatic(event) {
        setPlatform_pubmatic(event);
    }

    function onChangeSiteDomain_web_pubmatic(event) {
        setSiteDomain_web_pubmatic(event.target.value.trim());

        if (event.target.value.trim().length > 0) {
            setSiteDomainIsRequiredError_web_pubmatic(false)
            if (!regexDomain.test(event.target.value.trim())) {
                setSiteDomainValidError_web_pubmatic(true);
            }
            else {
                setSiteDomainValidError_web_pubmatic(false);
            }
        }
        else {
            setSiteDomainValidError_web_pubmatic(false)
            setSiteDomainIsRequiredError_web_pubmatic(true)
        }


    }

    function onChangeSiteIdentifier_web_pubmatic(event) {
        setSiteIdentifierIsRequiredError_web_pubmatic(false);
        setSiteIdentifier_web_pubmatic(event.target.value);

        if (event.target.value.length === 0) {
            setSiteIdentifierIsRequiredError_web_pubmatic(true);
        }
    }

    function onBlurSiteIdentifier_web_pubmatic(event) {
        if (event.target.value.trim().length === 0) {
            setSiteIdentifierIsRequiredError_web_pubmatic(true);
        }
        setSiteIdentifier_web_pubmatic(event.target.value.trim());
    }



    function onChangeCheckoxSecure_web_pubmatic(event) {
        setCheckbox_secure_web_pubmatic(event.target.checked);
    }


    function onChangeCheckoxCoppa_web_pubmatic(event) {
        setCheckbox_coppa_web_pubmatic(event.target.checked);
    }


    function onChangeCheckoxApi_web_pubmatic(event) {
        setCheckbox_api_web_pubmatic(event.target.checked);
    }


    function onChangeIabCategory_web_pubmatic(event) {
        setIabCategoryIsRequiredError_web_pubmatic(false)
        setIabCategory_web_pubmatic(event);
    }


    function onChangeMonthlyAdImpression_web_pubmatic(event) {
        setMonthlyAdImpression_web_pubmatic(event);
    }


    function onChangeContentObject_web_pubmatic(event) {
        setContentObject_web_pubmatic(event.target.value);
    }


    function onChangePrivacyPolicy_web_pubmatic(event) {
        setPrivacyPolicyUrl_web_pubmatic(event.target.value);
        setPrivacyPolicyUrlInvalidError_web_pubmatic(false);
    }

    function onBlurPrivacyPolicy_web_pubmatic(event) {
        setPrivacyPolicyUrl_web_pubmatic(event.target.value.trim());
        if (event.target.value.trim().length > 0) {
            if (!regexDomain.test(event.target.value.trim())) {
                setPrivacyPolicyUrlInvalidError_web_pubmatic(true);
            }
            else {
                setPrivacyPolicyUrlInvalidError_web_pubmatic(false);
            }
        }
    }


    //specific fields  ctv only

    // const [checkbox_overridePublisherData_ctv_pubmatic, setCheckbox_overridePublisherData_ctv_pubmatic] = useState(false);


    // function onChangeCheckoxOverridePublisherData_ctv_pubmatic(event) {
    //     setCheckbox_overridePublisherData_ctv_pubmatic(event.target.checked);
    // }






    // ---------------------------------------------------------------------------------------------------------------------------------------//
    // ----------------------------------------------------- Android / IOS -------------------------------------------------------------------//
    // ---------------------------------------------------------------------------------------------------------------------------------------//

    const [siteDomain_app_pubmatic, setSiteDomain_app_pubmatic] = useState("");
    const [siteDomainIsRequiredError_app_pubmatic, setSiteDomainIsRequiredError_app_pubmatic] = useState(false);
    const [siteDomainValidError_app_pubmatic, setSiteDomainValidError_app_pubmatic] = useState(false);

    const [siteIdentifier_app_pubmatic, setSiteIdentifier_app_pubmatic] = useState("");
    const [siteIdentifierIsRequiredError_app_pubmatic, setSiteIdentifierIsRequiredError_app_pubmatic] = useState(false);

    const [checkbox_secure_app_pubmatic, setCheckbox_secure_app_pubmatic] = useState(false);

    const [checkbox_availableOnAppStore_app_pubmatic, setCheckbox_availableOnAppStore_app_pubmatic] = useState(false);

    const [storeUrl_app_pubmatic, setStoreUrl_app_pubmatic] = useState("");
    const [storeUrlLoader_app_pubmatic, setStoreUrlLoader_app_pubmatic] = useState(false);
    const [storeUrlIsRequiredError_app_pubmatic, setStoreUrlIsRequiredError_app_pubmatic] = useState(false);
    const [storeUrlValidError_app_pubmatic, setStoreUrlValidError_app_pubmatic] = useState(false);
    const [storeUrlValidErrorMsg_app_pubmatic, setStoreUrlValidErrorMsg_app_pubmatic] = useState("");


    const [iabCategory_app_pubmatic, setIabCategory_app_pubmatic] = useState("");
    const [iabCategoryIsRequiredError_app_pubmatic, setIabCategoryIsRequiredError_app_pubmatic] = useState(false);
    const [iabCategoryOptions_app_pubmatic, setIabCategoryOptions_app_pubmatic] = useState([]);

    const [monthlyAdImpression_app_pubmatic, setMonthlyAdImpression_app_pubmatic] = useState(">1M");
    const [monthlyAdImpressionOptions_app_pubmatic] = useState([{ label: "<10000", value: "<10000" }, { label: ">10000", value: ">10000" }, { label: ">100000", value: ">100000" }, { label: ">1M", value: ">1M" }, { label: ">10M", value: ">10M" }, { label: ">100M", value: ">100M" }, { label: ">1B", value: ">1B" }]);

    const [checkbox_coppa_app_pubmatic, setCheckbox_coppa_app_pubmatic] = useState(false);

    const [privacyPolicyUrl_app_pubmatic, setPrivacyPolicyUrl_app_pubmatic] = useState("");
    const [privacyPolicyUrlInvalidError_app_pubmatic, setPrivacyPolicyUrlInvalidError_app_pubmatic] = useState(false);

    const [checkbox_overridePublisherData_app_pubmatic, setCheckbox_overridePublisherData_app_pubmatic] = useState(false);

    const [checkbox_api_app_pubmatic, setCheckbox_api_app_pubmatic] = useState(false);
    const [contentObject_app_pubmatic, setContentObject_app_pubmatic] = useState("0");
    const [richMediaCompliance_app_pubmatic, setRichMediaCompliance_app_pubmatic] = useState([]);

    const [appName_app_pubmatic, setAppName_app_pubmatic] = useState("");
    const [appId_app_pubmatic, setAppId_app_pubmatic] = useState("");
    const [bundle_app_pubmatic, setBundle_app_pubmatic] = useState("");
    const [version_app_pubmatic, setVersion_app_pubmatic] = useState("");
    const [appStoreCategory_app_pubmatic, setAppStoreCategory_app_pubmatic] = useState("");
    const [appStoreSecondaryCategory_app_pubmatic, setAppStoreSecondaryCategory_app_pubmatic] = useState("");
    const [paid_app_pubmatic, setPaid_app_pubmatic] = useState(false);


    function resetAndroidIOS() {
        setSiteDomain_app_pubmatic("");
        setSiteDomainIsRequiredError_app_pubmatic(false);
        setSiteDomainValidError_app_pubmatic(false);

        setSiteIdentifier_app_pubmatic("");
        setSiteIdentifierIsRequiredError_app_pubmatic(false);

        setCheckbox_secure_app_pubmatic(false);
        setCheckbox_availableOnAppStore_app_pubmatic(false);

        setStoreUrl_app_pubmatic("");
        setStoreUrlLoader_app_pubmatic(false);
        setStoreUrlIsRequiredError_app_pubmatic(false);
        setStoreUrlValidError_app_pubmatic(false);
        setStoreUrlValidErrorMsg_app_pubmatic("");

        setIabCategory_app_pubmatic("");
        setIabCategoryIsRequiredError_app_pubmatic(false);

        setMonthlyAdImpression_app_pubmatic(">1M");
        setCheckbox_coppa_app_pubmatic(false);

        setPrivacyPolicyUrl_app_pubmatic("");
        setPrivacyPolicyUrlInvalidError_app_pubmatic(false);

        setCheckbox_overridePublisherData_app_pubmatic(false);
        setCheckbox_api_app_pubmatic(false);

        setContentObject_app_pubmatic("0");
        setRichMediaCompliance_app_pubmatic([]);

        setAppName_app_pubmatic("");
        setAppId_app_pubmatic("");
        setBundle_app_pubmatic("");
        setVersion_app_pubmatic("");
        setAppStoreCategory_app_pubmatic("");
        setAppStoreSecondaryCategory_app_pubmatic("");
        setPaid_app_pubmatic(false);
    }

    function onChangeSiteDomain_app_pubmatic(event) {
        setPlatform_pubmatic(event);
    }

    function onChangeSiteDomain_app_pubmatic(event) {
        setSiteDomain_app_pubmatic(event.target.value.trim());

        if (event.target.value.trim().length > 0) {
            setSiteDomainIsRequiredError_app_pubmatic(false)
            if (!regexDomain.test(event.target.value.trim())) {
                setSiteDomainValidError_app_pubmatic(true);
            }
            else {
                setSiteDomainValidError_app_pubmatic(false);
            }
        }
        else {
            setSiteDomainValidError_app_pubmatic(false)
            setSiteDomainIsRequiredError_app_pubmatic(true)
        }


    }

    function onChangeSiteIdentifier_app_pubmatic(event) {
        setSiteIdentifierIsRequiredError_app_pubmatic(false);
        setSiteIdentifier_app_pubmatic(event.target.value);

        if (event.target.value.length === 0) {
            setSiteIdentifierIsRequiredError_app_pubmatic(true);
        }
    }

    function onBlurSiteIdentifier_app_pubmatic(event) {
        if (event.target.value.trim().length === 0) {
            setSiteIdentifierIsRequiredError_app_pubmatic(true);
        }
        setSiteIdentifier_app_pubmatic(event.target.value.trim());
    }



    function onChangeCheckoxSecure_app_pubmatic(event) {
        setCheckbox_secure_app_pubmatic(event.target.checked);
    }


    function onChangeStoreUrl_app_pubmatic(event) {
        setStoreUrl_app_pubmatic(event.target.value.trim());
        setStoreUrlIsRequiredError_app_pubmatic(false)
        setStoreUrlValidError_app_pubmatic(false)


        if (event.target.value?.trim().length === 0) {
            setStoreUrlLoader_app_pubmatic(false)
        }
    }


    function onChangeStoreUrl_ctv_pubmatic(event) {
        setStoreUrl_app_pubmatic(event.target.value.trim());

        if (event.target.value.trim().length > 0) {
            setStoreUrlIsRequiredError_app_pubmatic(false)
            if (!regexDomain.test(event.target.value.trim())) {
                setStoreUrlValidError_app_pubmatic(true);
            }
            else {
                setStoreUrlValidError_app_pubmatic(false);
            }
        }
        else {
            setStoreUrlValidError_app_pubmatic(false)
            setStoreUrlIsRequiredError_app_pubmatic(true)
        }

    }




    function onChangeCheckoxAvailableOnAppStore_app_pubmatic(event) {

        setCheckbox_availableOnAppStore_app_pubmatic(event.target.value);

        if (!event.target.value) {
            setStoreUrl_app_pubmatic("")
            setAppName_app_pubmatic("");
            setAppId_app_pubmatic("");
            setBundle_app_pubmatic("");
            setVersion_app_pubmatic("");
            setAppStoreCategory_app_pubmatic("");
            setAppStoreSecondaryCategory_app_pubmatic("");
            setPaid_app_pubmatic(false);

            setRichMediaCompliance_app_pubmatic([])
            setCheckbox_overridePublisherData_app_pubmatic(false)

        }
    }



    function onChangeCheckoxCoppa_app_pubmatic(event) {
        setCheckbox_coppa_app_pubmatic(event.target.checked);
    }


    function onChangeCheckoxApi_app_pubmatic(event) {
        setCheckbox_api_app_pubmatic(event.target.checked);
    }


    function onChangeIabCategory_app_pubmatic(event) {
        setIabCategoryIsRequiredError_app_pubmatic(false)
        setIabCategory_app_pubmatic(event);
    }


    function onChangeMonthlyAdImpression_app_pubmatic(event) {
        setMonthlyAdImpression_app_pubmatic(event);
    }


    function onChangeContentObject_app_pubmatic(event) {
        setContentObject_app_pubmatic(event.target.value);
    }


    function onChangeRichMediaCompliance_app_pubmatic(event) {
        setRichMediaCompliance_app_pubmatic(event);
    }

    function onChangePrivacyPolicy_app_pubmatic(event) {
        setPrivacyPolicyUrl_app_pubmatic(event.target.value);
        setPrivacyPolicyUrlInvalidError_app_pubmatic(false);
    }

    function onBlurPrivacyPolicy_app_pubmatic(event) {
        setPrivacyPolicyUrl_app_pubmatic(event.target.value.trim());
        if (event.target.value.trim().length > 0) {
            if (!regexDomain.test(event.target.value.trim())) {
                setPrivacyPolicyUrlInvalidError_app_pubmatic(true);
            }
            else {
                setPrivacyPolicyUrlInvalidError_app_pubmatic(false);
            }
        }
    }


    function onChangeCheckoxOverridePublisherData_app_pubmatic(event) {
        setCheckbox_overridePublisherData_app_pubmatic(event.target.checked);
    }



    /////////////////////////////////////////////////ctv/////////////////////////////////////////////////////////////////////////////

    function resetCtv() {
        setAppStore_ctv_pubmatic(999999)
        setBundleId_ctv_pubmatic("")
        setAppId_ctv_pubmatic("")

    }

    const [appStore_ctv_pubmatic, setAppStore_ctv_pubmatic] = useState(999999);
    const [appStoreOptions_ctv_pubmatic] = useState([{ label: "Roku", value: 3 }, { label: "TV Os", value: 4 }, { label: "Fire TV", value: 5 }, { label: "Vizio", value: 7 }, { label: "Samsung", value: 8 }, { label: "LG TV", value: 6 }, { label: "Google TV", value: 9 }, { label: "Other", value: 999999 }]);



    function onChangeAppStore_ctv_pubmatic(event) {
        setAppStore_ctv_pubmatic(event);

        setBundleId_ctv_pubmatic("")
        setAppId_ctv_pubmatic("")
        setStoreUrl_app_pubmatic("")
        setStoreUrlLoader_app_pubmatic(false)
        setStoreUrlIsRequiredError_app_pubmatic(false)
        setStoreUrlValidError_app_pubmatic(false)
        setStoreUrlValidErrorMsg_app_pubmatic("")

    }

    const [bundleId_ctv_pubmatic, setBundleId_ctv_pubmatic] = useState("");

    function onChangeBundleId_ctv_pubmatic(event) {
        setBundleId_ctv_pubmatic(event.target.value);
    }

    const [appId_ctv_pubmatic, setAppId_ctv_pubmatic] = useState("");

    function onChangeAppId_ctv_pubmatic(event) {
        if (/^\d*$/.test(event.target.value.trim())) {
            setAppId_ctv_pubmatic(event.target.value.trim());
        }
    }









    // ---------------------------------------------------------------------------------------------------------------------------------------//
    // ---------------------------------------------------------------------------------------------------------------------------------------//

    useEffect(() => {
        if ((platform_pubmatic !== 7 && storeUrl_app_pubmatic.trim() !== "" && !storeUrlValidError_app_pubmatic) || (platform_pubmatic === 7 && appStore_ctv_pubmatic !== 999999 && storeUrl_app_pubmatic.trim() !== "" && !storeUrlValidError_app_pubmatic)) {
            const delayDebounceFn = setTimeout(() => {
                setAppName_app_pubmatic("");
                setAppId_app_pubmatic("");
                setBundle_app_pubmatic("");
                setVersion_app_pubmatic("");
                setAppStoreCategory_app_pubmatic("");
                setAppStoreSecondaryCategory_app_pubmatic("");
                setPaid_app_pubmatic(false);
                setIabCategoryIsRequiredError_app_pubmatic(false)

                setStoreUrlLoader_app_pubmatic(true)

                axios
                    .post(configData.SERVER_URL + "ops/pubmatic/lookupApp",
                        {
                            appStoreUrl: storeUrl_app_pubmatic,
                            platformId: platform_pubmatic,
                            appStoreId: platform_pubmatic === 7 ? appStore_ctv_pubmatic : null
                        }, {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    })
                    .then((response) => {
                        setAppName_app_pubmatic(response.data.data.applicationName)
                        setAppId_app_pubmatic(response.data.data.appId)
                        setBundle_app_pubmatic(response.data.data.bundle)
                        setVersion_app_pubmatic(response.data.data.version)
                        setAppStoreCategory_app_pubmatic(response.data.data.primaryAppCatName)
                        setAppStoreSecondaryCategory_app_pubmatic(response.data.data.secondaryCatName)
                        setPaid_app_pubmatic(response.data.data.paid)
                        setIabCategory_app_pubmatic(response.data.data.category)
                        setStoreUrlLoader_app_pubmatic(false)
                    })
                    .catch((error) => {

                        setStoreUrlLoader_app_pubmatic(false)
                        setStoreUrlValidError_app_pubmatic(true)
                        if (error?.response) {
                            if (error?.response?.data?.message?.length !== 0) {
                                //   notifyfailure(error.response.data.message)
                                setStoreUrlValidErrorMsg_app_pubmatic(error?.response?.data?.message)
                            }
                        } else {
                            // notifycatch()
                        }

                    });

            }, 1000); // 500ms delay
            // Cleanup function to clear the timeout if query changes
            return () => clearTimeout(delayDebounceFn);
        }
    }, [storeUrl_app_pubmatic]);


    const siteDomain_web_pubmatic_ref = useRef(null)
    const siteIdentifier_web_pubmatic_ref = useRef(null)

    const siteDomain_app_pubmatic_ref = useRef(null)
    const siteIdentifier_app_pubmatic_ref = useRef(null)
    const iabCategory_app_pubmatic_ref = useRef(null)
    const privacyPolicyUrl_app_pubmatic_ref = useRef(null)
    const storeUrl_app_pubmatic_ref = useRef(null)

    const storeUrl_ctv_pubmatic_ref = useRef(null)




    const errorDetect = () => {

        if (platform_pubmatic === 1) {

            if (siteDomain_web_pubmatic.trim() === "" || siteDomainValidError_web_pubmatic) {
                scrollToItem(siteDomain_web_pubmatic_ref);
                return
            }

            if (siteIdentifier_web_pubmatic.trim() === "") {
                scrollToItem(siteIdentifier_web_pubmatic_ref);
                return
            }
        }



        if (platform_pubmatic === 4 || platform_pubmatic === 5) {

            if (siteDomain_app_pubmatic.trim() === "" || siteDomainValidError_app_pubmatic) {
                scrollToItem(siteDomain_app_pubmatic_ref);
                return
            }

            if (siteIdentifier_app_pubmatic.trim() === "") {
                scrollToItem(siteIdentifier_app_pubmatic_ref);
                return
            }

            if (checkbox_availableOnAppStore_app_pubmatic && (storeUrl_app_pubmatic.trim() === "" || storeUrlValidError_app_pubmatic)) {
                scrollToItem(storeUrl_app_pubmatic_ref);
                return
            }

            if (iabCategory_app_pubmatic.trim() === "") {
                scrollToItem(iabCategory_app_pubmatic_ref);
                return
            }

            if (privacyPolicyUrlInvalidError_app_pubmatic) {
                scrollToItem(privacyPolicyUrl_app_pubmatic_ref);
                return
            }


        }

        if (platform_pubmatic === 7) {

            if (siteDomain_app_pubmatic.trim() === "" || siteDomainValidError_app_pubmatic) {
                scrollToItem(siteDomain_app_pubmatic_ref);
                return
            }

            if (siteIdentifier_app_pubmatic.trim() === "") {
                scrollToItem(siteIdentifier_app_pubmatic_ref);
                return
            }


            if ((storeUrl_app_pubmatic.trim() === "" || storeUrlValidError_app_pubmatic)) {
                scrollToItem(storeUrl_ctv_pubmatic_ref);
                return
            }

            if (iabCategory_app_pubmatic.trim() === "") {
                scrollToItem(iabCategory_app_pubmatic_ref);
                return
            }

            if (privacyPolicyUrlInvalidError_app_pubmatic) {
                scrollToItem(privacyPolicyUrl_app_pubmatic_ref);
                return
            }

        }

    }


    const handleSubmit = async (e) => {
        e.preventDefault();

        errorDetect()

        //web
        if (platform_pubmatic === 1) {

            if (
                siteDomain_web_pubmatic?.trim() !== "" &&
                siteIdentifier_web_pubmatic?.trim() !== "" &&
                iabCategory_web_pubmatic !== ""
            ) {
                if (
                    siteDomainIsRequiredError_web_pubmatic === false &&
                    siteDomainValidError_web_pubmatic === false &&
                    siteIdentifierIsRequiredError_web_pubmatic === false &&
                    iabCategoryIsRequiredError_web_pubmatic === false &&
                    privacyPolicyUrlInvalidError_web_pubmatic === false
                ) {


                    let payload = {
                        platformId: platform_pubmatic,
                        siteOrAppDomain: siteDomain_web_pubmatic?.trim(),
                        name: siteIdentifier_web_pubmatic?.trim(),
                        forceSecure: checkbox_secure_web_pubmatic,
                        category: iabCategory_web_pubmatic,
                        monthlyImp: monthlyAdImpression_web_pubmatic,
                        isCoppaCompliant: checkbox_coppa_web_pubmatic,
                        privacyPolicyUrl: privacyPolicyUrl_web_pubmatic?.trim(),
                        contentObjPreference: Number(contentObject_web_pubmatic),
                        apiSetting: checkbox_api_web_pubmatic
                    }
                    // :
                    // {
                    //     platformId: platform_pubmatic,
                    //     siteOrAppDomain: siteDomain_web_pubmatic?.trim(),
                    //     name: siteIdentifier_web_pubmatic?.trim(),
                    //     forceSecure: checkbox_secure_web_pubmatic,
                    //     category: iabCategory_web_pubmatic,
                    //     monthlyImp: monthlyAdImpression_web_pubmatic,
                    //     isCoppaCompliant: checkbox_coppa_web_pubmatic,
                    //     privacyPolicyUrl: privacyPolicyUrl_web_pubmatic?.trim(),
                    //     contentObjPreference: Number(contentObject_web_pubmatic),
                    //     apiSetting: checkbox_api_web_pubmatic,
                    //     override_publisher_data: checkbox_overridePublisherData_ctv_pubmatic,
                    //     appstore: Number(appStore_ctv_pubmatic)
                    // }


                    setButtonProcessing(true)

                    let status = Cookies.get("token_xapads_ssp") ? true : false;
                    if (status) {
                        let token = Cookies.get("token_xapads_ssp");

                        axios
                            .post(configData.SERVER_URL + `ops/pubmatic/createSite`, payload, {
                                headers: {
                                    'Content-Type': 'application/json',
                                    "x-access-token": token,
                                },
                            })
                            .then((response) => {
                                notifysuccess(response.data.message);
                                setTimeout(() => {
                                    handlePageViewChange("table", "yes")
                                }, 1000)

                            })
                            .catch((error) => {
                                if (error?.response) {
                                    if (error.response.data.message?.length !== 0) {
                                        notifyfailure(error.response.data.message);
                                        setButtonProcessing(false)
                                    }
                                } else {
                                    notifycatch();
                                    setButtonProcessing(false)
                                }

                            });
                    }


                }
            } else {

                if (siteDomain_web_pubmatic.trim() === "") {
                    setSiteDomainIsRequiredError_web_pubmatic(true);
                }
                if (siteIdentifier_web_pubmatic.trim() === "") {
                    setSiteIdentifierIsRequiredError_web_pubmatic(true);
                }

                if (iabCategory_web_pubmatic === "") {
                    setIabCategoryIsRequiredError_web_pubmatic(true);
                }
            }
        }


        //android and ios 
        if (platform_pubmatic === 4 || platform_pubmatic === 5) {

            if (
                siteDomain_app_pubmatic?.trim() !== "" &&
                siteIdentifier_app_pubmatic?.trim() !== "" &&
                (checkbox_availableOnAppStore_app_pubmatic ? storeUrl_app_pubmatic.trim() !== "" : true) &&
                iabCategory_app_pubmatic !== ""
            ) {
                if (
                    siteDomainIsRequiredError_app_pubmatic === false &&
                    siteDomainValidError_app_pubmatic === false &&
                    siteIdentifierIsRequiredError_app_pubmatic === false &&
                    (checkbox_availableOnAppStore_app_pubmatic ? storeUrlIsRequiredError_app_pubmatic === false : true) &&
                    (checkbox_availableOnAppStore_app_pubmatic ? storeUrlValidError_app_pubmatic === false : true) &&
                    iabCategoryIsRequiredError_app_pubmatic === false &&
                    privacyPolicyUrlInvalidError_app_pubmatic === false
                ) {


                    let payload =
                    {
                        platformId: platform_pubmatic,
                        siteOrAppDomain: siteDomain_app_pubmatic?.trim(),
                        name: siteIdentifier_app_pubmatic?.trim(),
                        forceSecure: checkbox_secure_app_pubmatic,
                        availableOnAppStore: checkbox_availableOnAppStore_app_pubmatic,
                        storeUrl: storeUrl_app_pubmatic?.trim(),
                        category: iabCategory_app_pubmatic,
                        monthlyImp: monthlyAdImpression_app_pubmatic,
                        isCoppaCompliant: checkbox_coppa_app_pubmatic,
                        privacyPolicyUrl: privacyPolicyUrl_app_pubmatic?.trim(),
                        apiSetting: checkbox_api_app_pubmatic,
                        override_publisher_data: checkbox_overridePublisherData_app_pubmatic,
                        contentObjPreference: Number(contentObject_app_pubmatic),
                        richMediaCompliance: richMediaCompliance_app_pubmatic,

                        appName: checkbox_availableOnAppStore_app_pubmatic ? appName_app_pubmatic : "",
                        appId: checkbox_availableOnAppStore_app_pubmatic ? appId_app_pubmatic : "",
                        bundle: checkbox_availableOnAppStore_app_pubmatic ? bundle_app_pubmatic : "",
                        version: checkbox_availableOnAppStore_app_pubmatic ? version_app_pubmatic : "",
                        appStoreCategory: checkbox_availableOnAppStore_app_pubmatic ? appStoreCategory_app_pubmatic : "",
                        appStoreSecondaryCategory: checkbox_availableOnAppStore_app_pubmatic ? appStoreSecondaryCategory_app_pubmatic : "",
                        paid: checkbox_availableOnAppStore_app_pubmatic ? paid_app_pubmatic : false,
                    }

                    setButtonProcessing(true)

                    let status = Cookies.get("token_xapads_ssp") ? true : false;
                    if (status) {
                        let token = Cookies.get("token_xapads_ssp");

                        axios
                            .post(configData.SERVER_URL + `ops/pubmatic/createSite`, payload, {
                                headers: {
                                    'Content-Type': 'application/json',
                                    "x-access-token": token,
                                },
                            })
                            .then((response) => {
                                notifysuccess(response.data.message);
                                setTimeout(() => {
                                    handlePageViewChange("table", "yes")
                                }, 1000)

                            })
                            .catch((error) => {
                                if (error?.response) {
                                    if (error.response.data.message?.length !== 0) {
                                        notifyfailure(error.response.data.message);
                                        setButtonProcessing(false)
                                    }
                                } else {
                                    notifycatch();
                                    setButtonProcessing(false)
                                }

                            });
                    }


                }
            } else {

                if (siteDomain_app_pubmatic?.trim() === "") {
                    setSiteDomainIsRequiredError_app_pubmatic(true);
                }
                if (siteIdentifier_app_pubmatic?.trim() === "") {
                    setSiteIdentifierIsRequiredError_app_pubmatic(true);
                }
                if (checkbox_availableOnAppStore_app_pubmatic && storeUrl_app_pubmatic?.trim() === "") {
                    setStoreUrlIsRequiredError_app_pubmatic(true);
                }

                if (iabCategory_app_pubmatic === "") {
                    setIabCategoryIsRequiredError_app_pubmatic(true);
                }
            }

        }

        //ctv
        if (platform_pubmatic === 7) {

            if (
                siteDomain_app_pubmatic?.trim() !== "" &&
                siteIdentifier_app_pubmatic?.trim() !== "" &&
                storeUrl_app_pubmatic.trim() !== "" &&
                iabCategory_app_pubmatic !== ""
            ) {
                if (
                    siteDomainIsRequiredError_app_pubmatic === false &&
                    siteDomainValidError_app_pubmatic === false &&
                    siteIdentifierIsRequiredError_app_pubmatic === false &&
                    storeUrlIsRequiredError_app_pubmatic === false &&
                    storeUrlValidError_app_pubmatic === false &&
                    iabCategoryIsRequiredError_app_pubmatic === false &&
                    privacyPolicyUrlInvalidError_app_pubmatic === false
                ) {


                    let payload =
                    {
                        platformId: platform_pubmatic,
                        siteOrAppDomain: siteDomain_app_pubmatic?.trim(),
                        name: siteIdentifier_app_pubmatic?.trim(),
                        forceSecure: checkbox_secure_app_pubmatic,
                        availableOnAppStore: checkbox_availableOnAppStore_app_pubmatic,
                        storeUrl: storeUrl_app_pubmatic?.trim(),
                        category: iabCategory_app_pubmatic,
                        monthlyImp: monthlyAdImpression_app_pubmatic,
                        isCoppaCompliant: checkbox_coppa_app_pubmatic,
                        privacyPolicyUrl: privacyPolicyUrl_app_pubmatic?.trim(),
                        apiSetting: checkbox_api_app_pubmatic,
                        override_publisher_data: checkbox_overridePublisherData_app_pubmatic,
                        contentObjPreference: Number(contentObject_app_pubmatic),

                        appStore: appStore_ctv_pubmatic,
                        bundleIdCtv: appStore_ctv_pubmatic === 999999 ? bundleId_ctv_pubmatic : "",
                        appIdCtv: appStore_ctv_pubmatic === 999999 ? appId_ctv_pubmatic : "",

                        appName: appStore_ctv_pubmatic !== 999999 ? appName_app_pubmatic : "",
                        appId: appStore_ctv_pubmatic !== 999999 ? appId_app_pubmatic : "",
                        bundle: appStore_ctv_pubmatic !== 999999 ? bundle_app_pubmatic : "",
                        version: appStore_ctv_pubmatic !== 999999 ? version_app_pubmatic : "",
                        appStoreCategory: appStore_ctv_pubmatic !== 999999 ? appStoreCategory_app_pubmatic : "",
                        appStoreSecondaryCategory: appStore_ctv_pubmatic !== 999999 ? appStoreSecondaryCategory_app_pubmatic : "",
                        paid: appStore_ctv_pubmatic !== 999999 ? paid_app_pubmatic : false,


                    }


                    setButtonProcessing(true)

                    let status = Cookies.get("token_xapads_ssp") ? true : false;
                    if (status) {
                        let token = Cookies.get("token_xapads_ssp");

                        axios
                            .post(configData.SERVER_URL + `ops/pubmatic/createSite`, payload, {
                                headers: {
                                    'Content-Type': 'application/json',
                                    "x-access-token": token,
                                },
                            })
                            .then((response) => {
                                notifysuccess(response.data.message);
                                setTimeout(() => {
                                    handlePageViewChange("table", "yes")
                                }, 1000)

                            })
                            .catch((error) => {
                                if (error?.response) {
                                    if (error.response.data.message?.length !== 0) {
                                        notifyfailure(error.response.data.message);
                                        setButtonProcessing(false)
                                    }
                                } else {
                                    notifycatch();
                                    setButtonProcessing(false)
                                }

                            });
                    }


                }
            } else {

                if (siteDomain_app_pubmatic?.trim() === "") {
                    setSiteDomainIsRequiredError_app_pubmatic(true);
                }
                if (siteIdentifier_app_pubmatic?.trim() === "") {
                    setSiteIdentifierIsRequiredError_app_pubmatic(true);
                }
                if (storeUrl_app_pubmatic?.trim() === "") {
                    setStoreUrlIsRequiredError_app_pubmatic(true);
                }

                if (iabCategory_app_pubmatic === "") {
                    setIabCategoryIsRequiredError_app_pubmatic(true);
                }
            }

        }
    }



    return (
        <>
            <div className="container_box--wrapper pt_header">
                <div className="container_box--breadcrumb">
                    <ul className="container_box--breadcrumb-list">
                        <li >
                            <Link onClick={() => {
                                handlePageViewChange("table", "no")
                            }}>
                                <img src={demandIcon} alt='USP' />
                                Pubmatic
                            </Link>

                        </li>
                        <li>
                            <Link onClick={() => {
                                handlePageViewChange("table", "no")
                            }}>

                                Sites
                            </Link>
                        </li>
                        <li className="primary">New Site</li>
                    </ul>
                </div>
                <div className="container_box--wrapper--title d_flex justify-content-between">
                    <div className="back_btn_d2">
                        <img src={backButton} className="img-fluid" alt=""
                            onClick={() => {
                                handlePageViewChange("table", "no")

                            }}
                        />
                        <h1 className="heading">
                            Create Site
                        </h1>
                    </div>
                </div>

                <div className="container_box--content pt_20">
                    <div className="container_box--width">

                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Site/App Type</label>
                                    <p className="sub_text">Please select site/app type</p>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                <label className="form_label">Platform * </label>
                                                <Select
                                                    // showSearch
                                                    className='form_select basic no_search'
                                                    placeholder="-Select-"
                                                    optionFilterProp="label"
                                                    onChange={onChangePlatform_pubmatic}
                                                    value={platform_pubmatic}
                                                    options={platformOptions_pubmatic}
                                                />
                                                <span className="error_content"> </span>
                                            </div>




                                            {platform_pubmatic === 1 ?

                                                <>
                                                    <div className="form_content_block--group hide_caret_after_select_value" ref={siteDomain_web_pubmatic_ref}>
                                                        <label className="form_label">Site Domain *</label>
                                                        <Input placeholder='https://' autocomplete="off"
                                                            className={(siteDomainIsRequiredError_web_pubmatic || siteDomainValidError_web_pubmatic) ? 'form_control basic error ' : 'form_control basic '}
                                                            value={siteDomain_web_pubmatic}
                                                            onChange={onChangeSiteDomain_web_pubmatic}
                                                        />
                                                        <span className="error_content">
                                                            {siteDomainIsRequiredError_web_pubmatic && (
                                                                <> This field is required</>
                                                            )}
                                                            {siteDomainValidError_web_pubmatic && (
                                                                <> Invalid Url</>
                                                            )} </span>
                                                    </div>

                                                    <Row gutter={16}>
                                                        <Col span={18}>
                                                            <div className="form_content_block--group mb-0 hide_caret_after_select_value" ref={siteIdentifier_web_pubmatic_ref}>
                                                                <label className="form_label">Site Identifier * </label>
                                                                <Input placeholder='Enter Site/App Identifier' autocomplete="off"
                                                                    className={siteIdentifierIsRequiredError_web_pubmatic ? 'form_control basic error ' : 'form_control basic '}
                                                                    value={siteIdentifier_web_pubmatic}
                                                                    onChange={onChangeSiteIdentifier_web_pubmatic}
                                                                    onBlur={onBlurSiteIdentifier_web_pubmatic}
                                                                />
                                                                <span className="error_content">

                                                                    {siteIdentifierIsRequiredError_web_pubmatic && (
                                                                        <> This field is required</>
                                                                    )}
                                                                </span>
                                                            </div>
                                                        </Col>
                                                        <Col>
                                                            <div className="form_content_block--group mb-0 mt-2 pt-1">
                                                                <label className="form_label invisible">checkbox </label>
                                                                <div className="primary_checkbox">
                                                                    <Checkbox id="checkbox_secure_web_pubmatic" name="checkbox_secure_web_pubmatic"
                                                                        checked={checkbox_secure_web_pubmatic}
                                                                        onChange={onChangeCheckoxSecure_web_pubmatic}
                                                                    >
                                                                        <span className="form_label">
                                                                            Secure
                                                                        </span>
                                                                    </Checkbox>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </>
                                                :
                                                <>
                                                    <div className="form_content_block--group hide_caret_after_select_value" ref={siteDomain_app_pubmatic_ref}>
                                                        <label className="form_label">App Domain *</label>
                                                        <Input placeholder='https://' autocomplete="off"
                                                            className={(siteDomainIsRequiredError_app_pubmatic || siteDomainValidError_app_pubmatic) ? 'form_control basic error ' : 'form_control basic '}
                                                            value={siteDomain_app_pubmatic}
                                                            onChange={onChangeSiteDomain_app_pubmatic}
                                                        />
                                                        <span className="error_content">
                                                            {siteDomainIsRequiredError_app_pubmatic && (
                                                                <> This field is required</>
                                                            )}
                                                            {siteDomainValidError_app_pubmatic && (
                                                                <> Invalid Url</>
                                                            )} </span>
                                                    </div>
                                                    <Row gutter={16}>
                                                        <Col span={18}>
                                                            <div className="form_content_block--group hide_caret_after_select_value" ref={siteIdentifier_app_pubmatic_ref}>
                                                                <label className="form_label">App Identifier * </label>
                                                                <Input placeholder='Enter Site/App Identifier' autocomplete="off"
                                                                    className={siteIdentifierIsRequiredError_app_pubmatic ? 'form_control basic error ' : 'form_control basic '}
                                                                    value={siteIdentifier_app_pubmatic}
                                                                    onChange={onChangeSiteIdentifier_app_pubmatic}
                                                                    onBlur={onBlurSiteIdentifier_app_pubmatic}
                                                                />
                                                                <span className="error_content">

                                                                    {siteIdentifierIsRequiredError_app_pubmatic && (
                                                                        <> This field is required</>
                                                                    )}
                                                                </span>
                                                            </div>
                                                        </Col>
                                                        <Col>
                                                            <div className="form_content_block--group mb-0 mt-2 pt-1">
                                                                <label className="form_label invisible">checkbox </label>
                                                                <div className="primary_checkbox">
                                                                    <Checkbox id="checkbox_secure_app_pubmatic" name="checkbox_secure_app_pubmatic"
                                                                        checked={checkbox_secure_app_pubmatic}
                                                                        onChange={onChangeCheckoxSecure_app_pubmatic}
                                                                    >
                                                                        <span className="form_label">
                                                                            Secure
                                                                        </span>
                                                                    </Checkbox>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    {platform_pubmatic === 7 &&
                                                        <div className="form_content_block--group  hide_caret_after_select_value">
                                                            <label className="form_label">App Store * </label>
                                                            <Select
                                                                showSearch
                                                                className='form_select basic '
                                                                placeholder="-Select-"
                                                                optionFilterProp="label"
                                                                onChange={onChangeAppStore_ctv_pubmatic}
                                                                value={appStore_ctv_pubmatic}
                                                                options={appStoreOptions_ctv_pubmatic}
                                                            />
                                                            <span className="error_content">


                                                            </span>
                                                        </div>
                                                    }

                                                    {platform_pubmatic !== 7 &&
                                                        <div className="form_content_block--group">
                                                            <label className="form_label">
                                                                Available on App Store
                                                            </label>
                                                            <Radio.Group className="form_radio equal_space two_equal_space_d2"
                                                                value={checkbox_availableOnAppStore_app_pubmatic}
                                                                onChange={onChangeCheckoxAvailableOnAppStore_app_pubmatic}
                                                            >
                                                                <Radio className="radio_btn" value={true}>
                                                                    Yes
                                                                </Radio>
                                                                <Radio className="radio_btn" value={false}>
                                                                    No
                                                                </Radio>
                                                            </Radio.Group>
                                                        </div>
                                                    }


                                                    {platform_pubmatic !== 7 ?
                                                        <div className="form_content_block--group hide_caret_after_select_value mb-0 " ref={storeUrl_app_pubmatic_ref}>
                                                            <label className="form_label">App Store URL/ Bundle ID/ App ID *</label>
                                                            <div className="laoding_input_form_d2">
                                                                <div className="position-relative">
                                                                    <Input className={(storeUrlIsRequiredError_app_pubmatic || storeUrlValidError_app_pubmatic) && checkbox_availableOnAppStore_app_pubmatic ? 'form_control basic error' : 'form_control basic '} placeholder='Enter App Store URL/ Bundle ID/ App ID' autocomplete="off"
                                                                        onChange={onChangeStoreUrl_app_pubmatic}
                                                                        value={storeUrl_app_pubmatic}
                                                                        disabled={!checkbox_availableOnAppStore_app_pubmatic}

                                                                    />
                                                                    {storeUrlLoader_app_pubmatic && checkbox_availableOnAppStore_app_pubmatic &&
                                                                        <img src={FullLoader} className="loader_img_d2" alt="" />
                                                                    }
                                                                </div>
                                                            </div>
                                                            <span className="error_content">
                                                                {storeUrlIsRequiredError_app_pubmatic && checkbox_availableOnAppStore_app_pubmatic && <>This field is required</>}
                                                                {storeUrlValidError_app_pubmatic && checkbox_availableOnAppStore_app_pubmatic && <>{storeUrlValidErrorMsg_app_pubmatic}</>} </span>
                                                        </div>

                                                        :
                                                        <>
                                                            <>
                                                                {appStore_ctv_pubmatic === 999999 ?
                                                                    <div className="form_content_block--group hide_caret_after_select_value" ref={storeUrl_ctv_pubmatic_ref}>
                                                                        <label className="form_label">App Store URL/ Bundle ID/ App ID *</label>
                                                                        <div className="laoding_input_form_d2">
                                                                            <div className="position-relative">
                                                                                <Input className={(storeUrlIsRequiredError_app_pubmatic || storeUrlValidError_app_pubmatic) ? 'form_control basic error' : 'form_control basic '} placeholder='Enter App Store URL/ Bundle ID/ App ID' autocomplete="off"
                                                                                    onChange={onChangeStoreUrl_ctv_pubmatic}
                                                                                    value={storeUrl_app_pubmatic}
                                                                                />
                                                                                {storeUrlLoader_app_pubmatic &&
                                                                                    <img src={FullLoader} className="loader_img_d2" alt="" />
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                        <span className="error_content">
                                                                            {storeUrlIsRequiredError_app_pubmatic && <>This field is required</>}
                                                                            {storeUrlValidError_app_pubmatic && <>Invalid Url</>} </span>
                                                                    </div>
                                                                    :
                                                                    <div className="form_content_block--group hide_caret_after_select_value mb-0" ref={storeUrl_ctv_pubmatic_ref}>
                                                                        <label className="form_label">App Store URL/ Bundle ID/ App ID *</label>
                                                                        <div className="laoding_input_form_d2">
                                                                            <div className="position-relative">
                                                                                <Input className={(storeUrlIsRequiredError_app_pubmatic || storeUrlValidError_app_pubmatic) ? 'form_control basic error' : 'form_control basic '} placeholder='Enter App Store URL/ Bundle ID/ App ID' autocomplete="off"
                                                                                    onChange={onChangeStoreUrl_app_pubmatic}
                                                                                    value={storeUrl_app_pubmatic}
                                                                                />
                                                                                {storeUrlLoader_app_pubmatic &&
                                                                                    <img src={FullLoader} className="loader_img_d2" alt="" />
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                        <span className="error_content">
                                                                            {storeUrlIsRequiredError_app_pubmatic && <>This field is required</>}
                                                                            {storeUrlValidError_app_pubmatic && <>{storeUrlValidErrorMsg_app_pubmatic}</>} </span>
                                                                    </div>
                                                                }
                                                            </>

                                                            {appStore_ctv_pubmatic === 999999 &&
                                                                <>

                                                                    <div className="form_content_block--group hide_caret_after_select_value ">
                                                                        <label className="form_label">Bundle ID </label>

                                                                        <Input className='form_control basic ' placeholder='Enter  Bundle ID' autocomplete="off"
                                                                            onChange={onChangeBundleId_ctv_pubmatic}
                                                                            value={bundleId_ctv_pubmatic}
                                                                        />
                                                                        <span className="error_content"> </span>
                                                                    </div>


                                                                    <div className="form_content_block--group hide_caret_after_select_value mb-0 ">
                                                                        <label className="form_label">App ID </label>

                                                                        <Input className='form_control basic ' placeholder='Enter  Bundle ID' autocomplete="off"
                                                                            onChange={onChangeAppId_ctv_pubmatic}
                                                                            value={appId_ctv_pubmatic}
                                                                        />
                                                                        <span className="error_content"> </span>
                                                                    </div>
                                                                </>
                                                            }

                                                        </>


                                                    }



                                                </>

                                            }


                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>


                        {platform_pubmatic === 1 ?

                            <Row gutter={16}>
                                <Col span={8}>
                                    <div className="container_box--label-info">
                                        <label>Configuration Preferences</label>
                                    </div>
                                </Col>

                                <Col span={16}>
                                    <div className="container_box--form-container">
                                        <Row gutter={16}>
                                            <Col span={24}>
                                                <div className="form_content_block--group  hide_caret_after_select_value">
                                                    <label className="form_label">Primary IAB Category * </label>
                                                    <Select
                                                        showSearch
                                                        className={iabCategoryIsRequiredError_web_pubmatic ? 'form_select basic  error' : 'form_select basic '}

                                                        optionFilterProp="label"
                                                        onChange={onChangeIabCategory_web_pubmatic}
                                                        value={iabCategory_web_pubmatic}
                                                        options={iabCategoryOptions_web_pubmatic}
                                                    />
                                                    <span className="error_content">{iabCategoryIsRequiredError_web_pubmatic && <>This field is required</>} </span>
                                                </div>
                                                <div className="form_content_block--group  hide_caret_after_select_value">
                                                    <label className="form_label">Monthly Ad Impressions * </label>
                                                    <Select
                                                        showSearch
                                                        className='form_select basic no_search'
                                                        placeholder="Select Monthly Ad Impressions"
                                                        optionFilterProp="label"
                                                        onChange={onChangeMonthlyAdImpression_web_pubmatic}
                                                        value={monthlyAdImpression_web_pubmatic}
                                                        options={monthlyAdImpressionOptions_web_pubmatic}
                                                    />
                                                    <span className="error_content"> </span>
                                                </div>
                                                <div className="form_content_block--group">
                                                    <div className="primary_checkbox">
                                                        <Checkbox id="checkbox_coppa_web_pubmatic" name="checkbox_coppa_web_pubmatic"
                                                            checked={checkbox_coppa_web_pubmatic}
                                                            onChange={onChangeCheckoxCoppa_web_pubmatic}
                                                        >
                                                            <span className="form_label">
                                                                COPPA Compliant
                                                            </span>
                                                        </Checkbox>
                                                    </div>
                                                </div>
                                                <div className="form_content_block--group hide_caret_after_select_value">
                                                    <label className="form_label">Privacy Policy URL</label>
                                                    <Input className={privacyPolicyUrlInvalidError_web_pubmatic ? 'form_control basic error' : 'form_control basic '} autocomplete="off"
                                                        value={privacyPolicyUrl_web_pubmatic}
                                                        onChange={onChangePrivacyPolicy_web_pubmatic}
                                                        onBlur={onBlurPrivacyPolicy_web_pubmatic}
                                                    />
                                                    <span className="error_content">
                                                        {privacyPolicyUrlInvalidError_web_pubmatic && (
                                                            <> Invalid Url</>
                                                        )} </span>
                                                </div>
                                                <div className="form_content_block--group">
                                                    <label className="form_label">
                                                        Content Object
                                                    </label>
                                                    <Radio.Group className="form_radio equal_space"
                                                        value={contentObject_web_pubmatic}
                                                        onChange={onChangeContentObject_web_pubmatic}
                                                    >
                                                        <Radio className="radio_btn" value='0'>
                                                            Pass All
                                                        </Radio>
                                                        <Radio className="radio_btn" value='1'>
                                                            Pass PMP
                                                        </Radio>
                                                        <Radio className="radio_btn" value='2'>
                                                            Don’t Pass
                                                        </Radio>
                                                    </Radio.Group>
                                                </div>
                                                {/* {platform_pubmatic === 7 &&
                                                    <div className="form_content_block--group ">
                                                        <div className="primary_checkbox">
                                                            <Checkbox id="checkbox_overridePublisherData_ctv_pubmatic" name="checkbox_overridePublisherData_ctv_pubmatic"
                                                                checked={checkbox_overridePublisherData_ctv_pubmatic}
                                                                onChange={onChangeCheckoxOverridePublisherData_ctv_pubmatic}
                                                            >
                                                                <span className="form_label">
                                                                    Override Publisher Data
                                                                </span>
                                                            </Checkbox>
                                                        </div>
                                                    </div>
                                                } */}
                                                <div className="form_content_block--group mb-0">
                                                    <div className="primary_checkbox">
                                                        <Checkbox id="checkbox_api_web_pubmatic" name="checkbox_api_web_pubmatic"
                                                            checked={checkbox_api_web_pubmatic}
                                                            onChange={onChangeCheckoxApi_web_pubmatic}
                                                        >
                                                            <span className="form_label">
                                                                API Settings
                                                            </span>
                                                        </Checkbox>
                                                    </div>
                                                </div>

                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                            :

                            <>
                                <Row gutter={16}>
                                    <Col span={8}>
                                        <div className="container_box--label-info">
                                            <label>General Preferences</label>
                                        </div>
                                    </Col>

                                    <Col span={16}>
                                        <div className="container_box--form-container">
                                            <Row gutter={16}>
                                                <Col span={24}>
                                                    <div className="form_content_block--group  hide_caret_after_select_value" ref={iabCategory_app_pubmatic_ref}>
                                                        <label className="form_label">Primary IAB Category * </label>
                                                        <Select
                                                            showSearch
                                                            className={iabCategoryIsRequiredError_app_pubmatic ? 'form_select basic  error' : 'form_select basic '}

                                                            optionFilterProp="label"
                                                            onChange={onChangeIabCategory_app_pubmatic}
                                                            value={iabCategory_app_pubmatic}
                                                            options={iabCategoryOptions_app_pubmatic}
                                                        />
                                                        <span className="error_content">{iabCategoryIsRequiredError_app_pubmatic && <>This field is required</>} </span>
                                                    </div>
                                                    <div className="form_content_block--group  hide_caret_after_select_value">
                                                        <label className="form_label">Monthly Ad Impressions * </label>
                                                        <Select

                                                            className='form_select basic no_search'
                                                            placeholder="Select Monthly Ad Impressions"
                                                            optionFilterProp="label"
                                                            onChange={onChangeMonthlyAdImpression_app_pubmatic}
                                                            value={monthlyAdImpression_app_pubmatic}
                                                            options={monthlyAdImpressionOptions_app_pubmatic}
                                                        />
                                                        <span className="error_content"> </span>
                                                    </div>
                                                    <div className="form_content_block--group">
                                                        <div className="primary_checkbox">
                                                            <Checkbox id="checkbox_coppa_app_pubmatic" name="checkbox_coppa_app_pubmatic"
                                                                checked={checkbox_coppa_app_pubmatic}
                                                                onChange={onChangeCheckoxCoppa_app_pubmatic}
                                                            >
                                                                <span className="form_label">
                                                                    COPPA Compliant
                                                                </span>
                                                            </Checkbox>
                                                        </div>
                                                    </div>
                                                    <div className="form_content_block--group hide_caret_after_select_value" ref={privacyPolicyUrl_app_pubmatic_ref}>
                                                        <label className="form_label">Privacy Policy URL</label>
                                                        <Input className={privacyPolicyUrlInvalidError_app_pubmatic ? 'form_control basic error' : 'form_control basic '} autocomplete="off"
                                                            value={privacyPolicyUrl_app_pubmatic}
                                                            onChange={onChangePrivacyPolicy_app_pubmatic}
                                                            onBlur={onBlurPrivacyPolicy_app_pubmatic}
                                                        />
                                                        <span className="error_content">
                                                            {privacyPolicyUrlInvalidError_app_pubmatic && (
                                                                <> Invalid Url</>
                                                            )} </span>
                                                    </div>
                                                    {((platform_pubmatic === 4 || platform_pubmatic === 5) && !checkbox_availableOnAppStore_app_pubmatic) ?
                                                        <div className="form_content_block--group">
                                                            <div className="primary_checkbox">
                                                                <Checkbox id="checkbox_overridePublisherData_app_pubmatic" name="checkbox_overridePublisherData_app_pubmatic"
                                                                    checked={false}
                                                                    disabled
                                                                >
                                                                    <span className="form_label">
                                                                        Override Publisher Data
                                                                    </span>
                                                                </Checkbox>
                                                            </div>
                                                        </div>
                                                        :
                                                        <div className="form_content_block--group">
                                                            <div className="primary_checkbox">
                                                                <Checkbox id="checkbox_overridePublisherData_app_pubmatic" name="checkbox_overridePublisherData_app_pubmatic"
                                                                    checked={checkbox_overridePublisherData_app_pubmatic}
                                                                    onChange={onChangeCheckoxOverridePublisherData_app_pubmatic}
                                                                >
                                                                    <span className="form_label">
                                                                        Override Publisher Data
                                                                    </span>
                                                                </Checkbox>
                                                            </div>
                                                        </div>
                                                    }
                                                    <div className="form_content_block--group">
                                                        <div className="primary_checkbox">
                                                            <Checkbox id="checkbox_api_app_pubmatic" name="checkbox_api_app_pubmatic"
                                                                checked={checkbox_api_app_pubmatic}
                                                                onChange={onChangeCheckoxApi_app_pubmatic}
                                                            >
                                                                <span className="form_label">
                                                                    API Settings
                                                                </span>
                                                            </Checkbox>
                                                        </div>
                                                    </div>
                                                    <div className="form_content_block--group">
                                                        <label className="form_label">
                                                            Content Object
                                                        </label>
                                                        <Radio.Group className="form_radio equal_space"
                                                            value={contentObject_app_pubmatic}
                                                            onChange={onChangeContentObject_app_pubmatic}
                                                        >
                                                            <Radio className="radio_btn" value='0'>
                                                                Pass All
                                                            </Radio>
                                                            <Radio className="radio_btn" value='1'>
                                                                Pass PMP
                                                            </Radio>
                                                            <Radio className="radio_btn" value='2'>
                                                                Don’t Pass
                                                            </Radio>
                                                        </Radio.Group>
                                                    </div>
                                                    {platform_pubmatic !== 7 &&

                                                        <>
                                                            {checkbox_availableOnAppStore_app_pubmatic === false ?

                                                                <div className="form_content_block--group mb-0">
                                                                    <label className="form_label">
                                                                        Rich Media Compliance
                                                                    </label>
                                                                    <div className='new_cls_for_checkboxgroup_d2'>
                                                                        <Checkbox.Group className="form_checkbox equal_space"
                                                                            value={[]}
                                                                            disabled
                                                                        >
                                                                            <Checkbox className="checkbox_btn" value="3">
                                                                                MRAID 1.0
                                                                            </Checkbox>
                                                                            <Checkbox className="checkbox_btn" value="4">
                                                                                ORMMA
                                                                            </Checkbox>
                                                                            <Checkbox className="checkbox_btn" value="5">
                                                                                MRAID 2.0
                                                                            </Checkbox>
                                                                        </Checkbox.Group>
                                                                    </div>
                                                                </div>

                                                                :
                                                                <div className="form_content_block--group mb-0">
                                                                    <label className="form_label">
                                                                        Rich Media Compliance
                                                                    </label>
                                                                    <div className='new_cls_for_checkboxgroup_d2'>
                                                                        <Checkbox.Group className="form_checkbox equal_space"
                                                                            value={richMediaCompliance_app_pubmatic}
                                                                            onChange={onChangeRichMediaCompliance_app_pubmatic}
                                                                        >
                                                                            <Checkbox className="checkbox_btn" value="3">
                                                                                MRAID 1.0
                                                                            </Checkbox>
                                                                            <Checkbox className="checkbox_btn" value="4">
                                                                                ORMMA
                                                                            </Checkbox>
                                                                            <Checkbox className="checkbox_btn" value="5">
                                                                                MRAID 2.0
                                                                            </Checkbox>
                                                                        </Checkbox.Group>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </>
                                                    }
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>

                                {(platform_pubmatic === 4 || platform_pubmatic === 5 || platform_pubmatic === 7) &&
                                    <>
                                        {((platform_pubmatic !== 7 && checkbox_availableOnAppStore_app_pubmatic) ? true : (platform_pubmatic !== 7 && !checkbox_availableOnAppStore_app_pubmatic) ? false : (platform_pubmatic === 7 && appStore_ctv_pubmatic !== 999999) ? true : false) ?
                                            // {checkbox_availableOnAppStore_app_pubmatic ?
                                            <Row gutter={16}>
                                                <Col span={8}>
                                                    <div className="container_box--label-info">
                                                        <label>App Specific</label>
                                                    </div>
                                                </Col>

                                                <Col span={16}>
                                                    <div className="container_box--form-container">
                                                        <Row gutter={16}>
                                                            <Col span={12}>
                                                                <div className="form_content_block--group hide_caret_after_select_value">
                                                                    <label className="form_label">App Name</label>
                                                                    <Input className='form_control basic ' placeholder='' autocomplete="off" disabled
                                                                        value={appName_app_pubmatic}
                                                                    />
                                                                    <span className="error_content"> </span>
                                                                </div>
                                                            </Col>
                                                            <Col span={12}>
                                                                <div className="form_content_block--group hide_caret_after_select_value">
                                                                    <label className="form_label">App ID</label>
                                                                    <Input className='form_control basic ' placeholder='' autocomplete="off" disabled
                                                                        value={appId_app_pubmatic}
                                                                    />
                                                                    <span className="error_content"> </span>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row gutter={16}>
                                                            <Col span={12}>
                                                                <div className="form_content_block--group hide_caret_after_select_value">
                                                                    <label className="form_label">Bundle</label>
                                                                    <Input className='form_control basic ' placeholder='' autocomplete="off" disabled
                                                                        value={bundle_app_pubmatic}
                                                                    />
                                                                    <span className="error_content"> </span>
                                                                </div>
                                                            </Col>
                                                            <Col span={12}>
                                                                <div className="form_content_block--group hide_caret_after_select_value">
                                                                    <label className="form_label">Version</label>
                                                                    <Input className='form_control basic ' placeholder='' autocomplete="off" disabled
                                                                        value={version_app_pubmatic}
                                                                    />
                                                                    <span className="error_content"> </span>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row gutter={16}>
                                                            <Col span={12}>
                                                                <div className="form_content_block--group hide_caret_after_select_value">
                                                                    <label className="form_label">App Store Category</label>
                                                                    <Input className='form_control basic ' placeholder='' autocomplete="off" disabled
                                                                        value={appStoreCategory_app_pubmatic}
                                                                    />
                                                                    <span className="error_content"> </span>
                                                                </div>
                                                            </Col>
                                                            <Col span={12}>
                                                                <div className="form_content_block--group hide_caret_after_select_value">
                                                                    <label className="form_label">App Store Secondary Category </label>
                                                                    <Input className='form_control basic ' placeholder='' autocomplete="off" disabled
                                                                        value={appStoreSecondaryCategory_app_pubmatic}
                                                                    />
                                                                    <span className="error_content"> </span>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <div className="form_content_block--group mb-0">
                                                            <div className="primary_checkbox">
                                                                <Checkbox id="checkboxEnabled" name="checkboxEnabled" disabled
                                                                    checked={paid_app_pubmatic}
                                                                >
                                                                    <span className="form_label">
                                                                        Paid
                                                                    </span>
                                                                </Checkbox>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                            :
                                            <></>
                                        }
                                    </>
                                }
                            </>

                        }

                    </div>
                    <div className="hr_custom mb_20"></div>
                    <div className="btn_group justify-content-end gap_8 pb_50">
                        {buttonProcessing ?
                            <>
                                <button className="w_120_d2 btn btn_white_outline w_fit_content"
                                    disabled
                                >
                                    Discard
                                </button>
                                <button
                                    className="w_120_d2 btn btn_primary w_fit_content loader"

                                >
                                    <span>Create Site</span>

                                    <img
                                        src={loaderIcon}
                                        alt="USP"
                                        className="loader_icon"
                                    />
                                </button>
                            </> :
                            <>
                                <button className="w_120_d2 btn btn_white_outline w_fit_content"
                                    onClick={() => {
                                        handlePageViewChange("table", "no")
                                    }}
                                > Discard </button>
                                <button className="w_120_d2 btn btn_primary w_fit_content"
                                    onClick={handleSubmit}
                                >Create Site</button>
                            </>
                        }
                    </div>
                </div>

            </div>
        </>
    )
}

export default SiteCreatePubmatic
